const balanceEndpoint = {
  cashInfo: '/balance/cash/info',
  cashOnHand: '/balance/cash',
};

export default balanceEndpoint;
